import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/global-board/images/empty-placeholder.svg'
import _imports_1 from '@/assets/generic-empty-state.svg'


const _withScopeId = n => (_pushScopeId("data-v-61412484"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col justify-center items-center min-h-screen" }
const _hoisted_3 = {
  key: 1,
  class: "w-full animate__animated animate__fadeIn animate__delay-0.4s"
}
const _hoisted_4 = { class: "h-full" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "relative sm:h-72 hero" }
const _hoisted_7 = {
  key: 0,
  class: "relative overflow-hidden max-w-full h-full w-full bottom-0 flex flex-col justify-between"
}
const _hoisted_8 = { class: "p-2 flex flex-row justify-between" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<span class=\"\" data-v-61412484><svg class=\"h-8 w-8 text-white\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-61412484><path stroke=\"none\" d=\"M0 0h24v24H0z\" data-v-61412484></path><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\" data-v-61412484></line><line x1=\"5\" y1=\"12\" x2=\"11\" y2=\"18\" data-v-61412484></line><line x1=\"5\" y1=\"12\" x2=\"11\" y2=\"6\" data-v-61412484></line></svg></span>", 1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "w-full bg-white flex flex-col justify-center items-center" }
const _hoisted_12 = { class: "w-full lg:w-10/12 flex flex-col mb-8 lg:px-12 lg:py-6 md:px-12 md:py-6 sm:px-4 sm:py-2 px-5 py-4" }
const _hoisted_13 = { class: "w-full flex lg:flex-row md:flex-row flex-col lg:space-x-8 md:space-x-8 justify-start items-start" }
const _hoisted_14 = { class: "relative z-50 bg-white shadow-card w-28 h-28 -mt-24 lg:w-52 lg:h-44 lg:-mt-32 rounded-lg flex flex-row justify-center items-center object-cover small-hero" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "w-full text-left mt-5 lg:mt-0 md:mt-0 lg:text-left md:text-left" }
const _hoisted_17 = { class: "text-gray-600 font-semibold lg:text-3xl text-lg" }
const _hoisted_18 = { class: "font-thin lg:text-xl md:text-sm md:text-justify text-gray-500 text-left lg:text-justify mt-1 leading-tight text-sm" }
const _hoisted_19 = { class: "bg-background" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col py-5 justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 lg:text-3xl text-2xl font-semibold" }, "Job Openings")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "lg:px-5 w-full"
}
const _hoisted_22 = { class: "flex flex-col lg:flex-row px-4 justify-center items-center space-y-3 lg:space-y-0" }
const _hoisted_23 = { class: "lg:w-full flex lg:flex-row flex-col w-full lg:bg-white space-y-3 lg:space-y-0 rounded-lg lg:shadow-xl" }
const _hoisted_24 = { class: "flex flex-row w-full lg:w-4/12 shadow-sm lg:shadow-none rounded-lg" }
const _hoisted_25 = { class: "flex flex-row w-full lg:w-4/12 shadow-sm lg:rounded-none lg:shadow-none rounded-lg lg:border-l-2" }
const _hoisted_26 = { class: "w-full flex flex-col lg:w-2/12 justify-start items-start p-4 bg-white rounded-lg shadow-sm lg:shadow-none lg:rounded-none lg:border-l-2" }
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-base font-medium text-gray-400",
  for: "remoteJob"
}, "Remote only", -1))
const _hoisted_29 = { class: "w-full flex flex-col lg:w-3/12 px-5 items-center justify-between lg:border-l-2 relative bg-white p-4 shadow-sm lg:shadow-none lg:rounded-none rounded-lg" }
const _hoisted_30 = {
  ref: "modal",
  class: "bg-white rounded-lg absolute mt-11 w-full z-50 lg:p-2 transition ease-in-out shadow-2xl"
}
const _hoisted_31 = { class: "w-full p-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lg:text-base text-sm font-semibold text-purple-500" }, "Select salary range", -1))
const _hoisted_33 = { class: "flex flex-row justify-between items-end space-x-1 mt-2" }
const _hoisted_34 = { class: "w-full flex flex-col" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Min:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_37 = { class: "w-full flex flex-col" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Max:", -1))
const _hoisted_39 = {
  key: 0,
  class: "w-full"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-red-400 text-center w-full" }, "Max field should be greater than min", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "border mt-2 p-2 rounded-lg" }
const _hoisted_43 = { class: "w-full mt-2 flex flex-row justify-end items-end space-x-1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Clear", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "Apply", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "w-full flex lg:flex-row md:flex-row flex-col p-4 lg:space-x-8 md:space-x-8 mt-8" }
const _hoisted_49 = { class: "lg:w-3/12 py-2 lg:visible invisible h-0 lg:h-full" }
const _hoisted_50 = { class: "bg-white shadow-card w-full rounded-lg" }
const _hoisted_51 = { class: "w-full p-8" }
const _hoisted_52 = { class: "w-full mb-8 flex flex-row justify-between items-center" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-xl text-primary" }, "Filters", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-purple-500" }, "Clear filters", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "mt-6" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-500" }, "Department", -1))
const _hoisted_58 = { class: "flex flex-col mt-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1))
const _hoisted_60 = { class: "mt-6" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-500" }, "Work type", -1))
const _hoisted_62 = { class: "flex flex-col mt-2" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-gray-500" }, "Seniority", -1))
const _hoisted_65 = { class: "flex flex-col mt-2" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-gray-100 py-2" }, null, -1))
const _hoisted_67 = {
  key: 0,
  class: "w-full flex flex-col lg:w-9/12 md:w-9/12 animate__animated animate__fadeIn animate__delay-0.4s -mt-6 lg:mt-0"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "w-full" }
const _hoisted_70 = {
  key: 1,
  class: "w-full h-9/12 flex flex-col justify-center items-center min-h-fit animate__animated animate__fadeIn animate__delay-0.4s p-12"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "no results",
  width: "400"
}, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl md:text-3xl lg:text-5xl font-extrabold text-purple-300" }, "No results found")
], -1))
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 1,
  class: "w-full flex flex-col lg:w-9/12 md:w-9/12"
}
const _hoisted_75 = {
  key: 1,
  class: "px-5 w-full"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-9/12 flex flex-col justify-center items-center min-h-fit animate__animated animate__fadeIn animate__delay-0.4s px-12 py-24" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "no results",
    width: "400"
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-xl md:text-3xl lg:text-5xl font-extrabold text-purple-300" }, "No job openings for now")
  ])
], -1))
const _hoisted_77 = [
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_CustomSearch = _resolveComponent("CustomSearch")!
  const _component_CurrencyField = _resolveComponent("CurrencyField")!
  const _component_SimpleSelect = _resolveComponent("SimpleSelect")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_JobCard = _resolveComponent("JobCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_PoweredByFooter = _resolveComponent("PoweredByFooter")!
  const _component_CustomCompany = _resolveComponent("CustomCompany")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoadingPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Loader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.currentRoute === 'Company')
            ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "flex flex-col relative sm:h-72 hero",
              style: _normalizeStyle({
          'background-color': `${_ctx.hexToRGBA(
            _ctx.company?.company_branding?.primary_color
              ? _ctx.company?.company_branding?.primary_color
              : '#740e85',
            1
          )}`,
        })
            }, [
              (_ctx.company?.company_branding?.background?.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.company?.company_branding?.background?.url,
                    class: "absolute inset-0 object-cover w-full h-full animate__animated animate__fadeIn animate__delay-0.4s",
                    alt: ""
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.currentRoute !== 'Company Board')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "flex flex-col p-2 hover:border hover:border-white rounded-lg",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/companies')))
                        }, _hoisted_10)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.company?.company_branding?.logo?.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "object-cover bg-white rounded-lg w-full h-full animate__animated animate__fadeIn animate__delay-0.4s",
                          src: _ctx.company?.company_branding?.logo?.url,
                          alt: ""
                        }, null, 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.company.visible_name), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.company.company_branding.description), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            (_ctx.company?.has_jobs)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_CustomSearch, {
                          modelValue: _ctx.inputJobValue,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputJobValue) = $event)),
                          class: "bg-white",
                          placeholder: "Search job",
                          onOnSubmit: _ctx.searchByJob
                        }, null, 8, ["modelValue", "onOnSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_CustomSearch, {
                          modelValue: _ctx.inputLocationValue,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputLocationValue) = $event)),
                          class: "bg-white",
                          icon: "pin",
                          placeholder: "Search location",
                          onOnSubmit: _ctx.searchByLocation
                        }, null, 8, ["modelValue", "onOnSubmit"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          class: "styled-checkbox",
                          id: "remoteJob",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remoteJob) = $event)),
                          value: _ctx.remoteJob
                        }, null, 8, _hoisted_27), [
                          [_vModelCheckbox, _ctx.remoteJob]
                        ]),
                        _hoisted_28
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          class: "w-full flex flex-row items-center justify-between",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand.salary = !_ctx.expand.salary))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["text-base font-medium", [
                    _ctx.isFilterbySalary
                      ? 'text-purple-600 font-semibold'
                      : 'text-gray-400',
                  ]])
                          }, _toDisplayString(_ctx.isFilterbySalary ? _ctx.salarySearch : "Salary Range"), 3),
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                    _ctx.expand.salary &&
                    'transform rotate-180 delay-150 ease-in-out'
                  ])
                          }, null, 2)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createVNode(_component_CurrencyField, {
                                  modelValue: _ctx.salaryMin,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.salaryMin) = $event)),
                                  label: "",
                                  name: "salaryMin",
                                  board: true
                                }, null, 8, ["modelValue"])
                              ]),
                              _hoisted_36,
                              _createElementVNode("div", _hoisted_37, [
                                _hoisted_38,
                                _createVNode(_component_CurrencyField, {
                                  modelValue: _ctx.salaryMax,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.salaryMax) = $event)),
                                  label: "",
                                  name: "salaryMax",
                                  board: true
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            (_ctx.salaryError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_42, [
                              _createVNode(_component_SimpleSelect, {
                                options: _ctx.optionCurrencies,
                                modelValue: _ctx.currecySalary,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currecySalary) = $event)),
                                label: "Select currency",
                                name: "currency"
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              (_ctx.isFilterbySalary)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearSalaryRange && _ctx.clearSalaryRange(...args))),
                                    class: "border border-primary px-5 py-2 rounded-lg text-primary rounded-full"
                                  }, _hoisted_45))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.searchBySalary && _ctx.searchBySalary(...args))),
                                class: "border border-primary bg-primary px-5 py-2 rounded-lg text-white rounded-full"
                              }, _hoisted_47)
                            ])
                          ])
                        ], 512), [
                          [_vShow, _ctx.expand.salary]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            (_ctx.isFilterClear)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "px-3 py-1 rounded-sm bg-gray-50",
                                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                                }, _hoisted_55))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.expand.department = !_ctx.expand.department)),
                              class: "flex flex-row justify-between items-center w-full"
                            }, [
                              _hoisted_57,
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                        _ctx.expand.department &&
                        'transform rotate-180 delay-150 ease-in-out'
                      ])
                              }, null, 2)
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_58, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionDepartament, (item, index) => {
                                return (_openBlock(), _createBlock(_component_RadioButton, {
                                  key: `radio-${item}-${index}`,
                                  label: item.name,
                                  value: item.id,
                                  modelValue: _ctx.RadioDepartment,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.RadioDepartment) = $event)),
                                  hasCounter: false
                                }, null, 8, ["label", "value", "modelValue"]))
                              }), 128))
                            ], 512), [
                              [_vShow, _ctx.expand.department]
                            ])
                          ]),
                          _hoisted_59,
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.expand.work_type = !_ctx.expand.work_type)),
                              class: "flex flex-row justify-between items-center w-full"
                            }, [
                              _hoisted_61,
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                        _ctx.expand.work_type &&
                        'transform rotate-180 delay-150 ease-in-out'
                      ])
                              }, null, 2)
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_62, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsEmployment, (item, index) => {
                                return (_openBlock(), _createBlock(_component_RadioButton, {
                                  key: `radio-${item}-${index}`,
                                  label: item.name,
                                  value: item.id,
                                  modelValue: _ctx.work_type,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.work_type) = $event)),
                                  hasCounter: false
                                }, null, 8, ["label", "value", "modelValue"]))
                              }), 128))
                            ], 512), [
                              [_vShow, _ctx.expand.work_type]
                            ])
                          ]),
                          _hoisted_63,
                          _createElementVNode("div", {
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.expand.seniority = !_ctx.expand.seniority)),
                            class: "flex flex-row justify-between items-center w-full mt-6"
                          }, [
                            _hoisted_64,
                            _createElementVNode("i", {
                              class: _normalizeClass(["fas fa-chevron-down text-gray-500 cursor-pointer", 
                      _ctx.expand.seniority &&
                      'transform rotate-180 delay-150 ease-in-out'
                    ])
                            }, null, 2)
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsExperience, (item, index) => {
                              return (_openBlock(), _createBlock(_component_RadioButton, {
                                key: `radio-${item}-${index}`,
                                label: item.name,
                                value: item.id,
                                modelValue: _ctx.radioSeniority,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.radioSeniority) = $event)),
                                hasCounter: false
                              }, null, 8, ["label", "value", "modelValue"]))
                            }), 128))
                          ], 512), [
                            [_vShow, _ctx.expand.seniority]
                          ]),
                          _hoisted_66
                        ])
                      ])
                    ]),
                    (!_ctx.isLoadingJobs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          (_ctx.companyJobs.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _createVNode(_component_JobCard, {
                                  jobs: _ctx.companyJobs,
                                  company: _ctx.$route.params.company_name
                                }, null, 8, ["jobs", "company"]),
                                _createElementVNode("div", _hoisted_69, [
                                  _createVNode(_component_Paginator, {
                                    modelValue: _ctx.page,
                                    page: _ctx.page,
                                    pages: _ctx.pagination?.total_pages,
                                    "range-size": 1,
                                    "onUpdate:modelValue": _ctx.updateHandler,
                                    total: _ctx.pagination?.total_count,
                                    from: _ctx.pagination?.from,
                                    to: _ctx.pagination?.to,
                                    class: "mt-8"
                                  }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_73))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item, index) => {
                            return _createElementVNode("div", {
                              class: "w-full",
                              key: index
                            }, [
                              _createVNode(_component_SkeletonCard, { type: "job-card" })
                            ])
                          }), 64))
                        ]))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77)),
            _createVNode(_component_PoweredByFooter)
          ])
        ])),
    _createVNode(_component_ReusableModal, {
      show: _ctx.openModal,
      onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openModal = false)),
      size: "w-2/4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CustomCompany, {
          onCloseModal: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openModal = false)),
          onUpdateBranding: _ctx.updateBranding,
          company: _ctx.company
        }, null, 8, ["onUpdateBranding", "company"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}